import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import config from './config';

function Routes() {
  return <Suspense fallback={null}>{useRoutes(config)}</Suspense>;
}

export default Routes;
